/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "utilities/Constants";
import { formatDeviceAddress } from "utilities/DeviceNameFormatter";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

export class FullReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      // Parte do monitor
      monitoringFirstResumePage: -1,
      monitoringFirstLiveListPage: -1,
      monitoringFirstLogPage: -1,
      // Parte de scope
      scopeFirstLiveListPage: -1,
      scopeFirstOscilloscopePage: -1,
      scopeFirstBarGraphPage: -1,
      scopeFirstLogPage: -1,
      // Parte do monitor
      isFirstMonitoringResumePage: true,
      isFirstMonitoringLiveListPage: true,
      isFirstMonitoringLogPage: true,
      // Parte de scope
      isFirstScopeLiveListPage: true,
      isFirstScopeOscilloscopePage: true,
      isFirstScopeBarGraphPage: true,
      isFirstScopeLogPage: true,
    };
  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getRectImage = (isFilled) => {
    if (isFilled) {
      return <Image src={`${process.env.PUBLIC_URL}/images/filled-rect.png`} style={generalInfoStyles.rectangle} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={generalInfoStyles.rectangle} />;
    }
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  getBaudRateText = (baudRate) => {
    let baudRateKbps = baudRate / 1000;
    let baudRateMbps = baudRate / 1000000;

    // If the baud rate is greater then 1000 Kbps show it as Mbps
    if (baudRateKbps >= 1000.00) {
      return baudRateMbps.toString().replace(".", ",") + " Mbps";
    }
    else {
      return baudRateKbps.toString().replace(".", ",") + " Kbps";
    }
  }

  getAmplitudeText = (device) => {
    return (device.amplitudeMedia.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK);
  }

  getAmplitudeMinText = (device) => {
    return (device.amplitudeMinima.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK);
  }

  getSlaveMasterText = (isMaster) => {
    if (isMaster) {
      return Strings.MASTER_DN;
    }
    else {
      return Strings.SLAVE_DN;
    }
  }

  getTagText = (device) => {
    if (device.mestre) {
      return "-";
    }
    else {
      return device.tag;
    }
  }

  getStatusText = (status) => {
    if (status === Constants.GOOD) {
      return Strings.GOOD_STRING_ANALYZER_DN;
    }
    else if (status === Constants.ATTENTION) {
      return Strings.ATTENTION_STRING;
    }
    else if (status === Constants.BAD) {
      return Strings.BAD_STRING_ANALYZER_DN;
    }
    else {
      return Strings.UNKNOWN_STRING;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.HEADER_TEXT_PROTOCOL}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, Página ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "monitoringResume" && this.state.isFirstMonitoringResumePage) {
      console.log(reportPart, pageNumber);
      this.setState({
        monitoringFirstResumePage: pageNumber,
        isFirstMonitoringResumePage: false
      });
    }
    else if (reportPart === "monitoringLiveList" && this.state.isFirstMonitoringLiveListPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        monitoringFirstLiveListPage: pageNumber,
        isFirstMonitoringLiveListPage: false
      });
    }
    else if (reportPart === "monitoringLog" && this.state.isFirstMonitoringLogPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        monitoringFirstLogPage: pageNumber,
        isFirstMonitoringLogPage: false
      });
    }
    else if (reportPart === "scopeLiveList" && this.state.isFirstScopeLiveListPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstLiveListPage: pageNumber,
        isFirstScopeLiveListPage: false
      });
    }
    else if (reportPart === "scopeOscilloscope" && this.state.isFirstScopeOscilloscopePage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstOscilloscopePage: pageNumber,
        isFirstScopeOscilloscopePage: false
      });
    }
    else if (reportPart === "scopeBarGraph" && this.state.isFirstScopeBarGraphPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstBarGraphPage: pageNumber,
        isFirstScopeBarGraphPage: false
      });
    }
    else if (reportPart === "scopeLog" && this.state.isFirstScopeLogPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstLogPage: pageNumber,
        isFirstScopeLogPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    return (
      <Document
        title={Strings.REPORT_EXPORT_NAME_PROTOCOL}>
        {this.createGeneralInfoPage()}
        {this.createDataInfoPage()}
        {this.createSummaryPage()}
        {/* Monitoring */}
        {this.creteResumePage()}
        {this.createMonitoringLiveListPages()}
        {this.createMonitoringLogPages()}
        {/* Scope */}
        {this.createScopeLiveListPages()}
        {this.createOscilloscopePages()}
        {this.createBarGraphPages()}
        {this.createScopeLogPages()}
        {/* Disclaimer */}
        {this.createDisclaimerPage()}
      </Document>
    );
  }

  // ----------------- General Information ---------------------
  createGeneralInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.GENERAL_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.CLIENT_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.PROJECT_NAME} {this.props.userInput.clientProjectName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME} {this.props.userInput.clientNetworkName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.LOCATION} {this.props.userInput.clientLocation}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_NAME} {this.props.userInput.clientCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.ACCOUNTABLE_NAME} {this.props.userInput.clientAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_ADDRESS} {this.props.userInput.clientAddress}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_CITY} {this.props.userInput.clientCity}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.COMPANY_TEL} {this.props.userInput.clientTel}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getClientImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.EXECUTING_COMPANY_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_COMPANY_NAME} {this.props.userInput.executingCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_ACCOUNTABLE_NAME} {this.props.userInput.executingAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_TEL} {this.props.userInput.executingTel}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.EXECUTING_EMAIL} {this.props.userInput.executingEmail}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getExecutorImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.ANNOTATIONS}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.notesSection}>
          <Text style={reusableStyles.normalText}>{this.props.userInput.notes}</Text>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.CONCLUSION}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.conclusionSection}>

          <View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_STRING}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM_W_RESTRICTION)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_W_RESTRICTION_STRING}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.NON_CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.NON_CONFORM_STRING}</Text>
            </View>

          </View>

          <View style={generalInfoStyles.signatureLine} />

        </View>

        {this.getPageFooter("")}

      </Page >
    );
  }

  getClientImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a client image
    if (this.props.userInput.clientImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.clientImg} />
      );
    }
  }

  getExecutorImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a executor image
    if (this.props.userInput.executorImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.executorImg} />
      );
    }
  }

  // ----------------- Data Information ------------------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.MONITORING_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.TAG_NAME_DN}{this.props.scopeTag} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_VERSION_DN}{Constants.TS_MONITOR_VERSION} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_INIT_DN}{UtilsInstance.getMonitorInitTime(this.props.uptime, UtilsInstance)} </Text>
        <Text style={reusableStyles.normalText}>{Strings.GENERATING_TIME_DN}{this.getDateTimeNow()} </Text>
        <Text style={reusableStyles.lastInfoText}>{Strings.DURATION_SINCE_MON_BEGIN}{UtilsInstance.formatToRelativeTime2(this.props.uptime, UtilsInstance)} </Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.ETHERNET_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.IP_DN}{this.props.configData.addr} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DN}{this.props.configData.netmask} </Text>
        <Text style={reusableStyles.lastInfoText}>{Strings.GATEWAY_DN}{this.props.configData.gateway} </Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.WLAN_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME_DN}{this.props.wifiConfigData.wifiName}</Text>
        <Text style={reusableStyles.normalText}>{Strings.IP_DN}{this.props.wifiConfigData.wifiAddr}</Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DN}{this.props.wifiConfigData.wifiNetmask}</Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DN}{this.props.wifiConfigData.wifiGateway}</Text>

        {this.getPageFooter("")}

      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        <Text style={reusableStyles.boldSummaryText} render={() => (
          `1. ${Strings.MONITORING} ${Strings.LIVE_LIST_DOTS_PROTOCOL} ${this.state.monitoringFirstResumePage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `1.1. ${Strings.RESUME} ${Strings.RESUME_DOTS} ${this.state.monitoringFirstResumePage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `1.2. ${Strings.LIVE_LIST} ${Strings.LIVE_LIST_DOTS_PROTOCOL} ${this.state.monitoringFirstLiveListPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `1.3. ${Strings.LOG} ${Strings.MON_LOG_DOTS} ${this.state.monitoringFirstLogPage}`
        )} fixed />

        <Text style={reusableStyles.boldSummaryText} render={() => (
          `2. ${Strings.PHYS_MEDIUM} ${Strings.LIVE_LIST_DOTS_ANALYZER_DN} ${this.state.scopeFirstLiveListPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `2.1. ${Strings.LIVE_LIST} ${Strings.LIVE_LIST_DOTS_ANALYZER_DN} ${this.state.scopeFirstLiveListPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `2.2. ${Strings.OSCILLOSCOPE} ${Strings.OSC_DOTS} ${this.state.scopeFirstOscilloscopePage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `2.3. ${Strings.BAR_GRAPH} ${Strings.BAR_DOTS} ${this.state.scopeFirstBarGraphPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `2.4. ${Strings.LOG} ${Strings.LOG_DOTS} ${this.state.scopeFirstLogPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `3. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_DOTS_PROTOCOL} ${totalPages}`
        )} fixed />

        {this.getPageFooter("")}

      </Page>
    );
  }

  // ----------------- Resumo -----------------
  creteResumePage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={monitoringLiveListStyles.pageTitle} fixed>{Strings.M_MONITORING_RESUME_PAGE_TITLE}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.DEVICENET_NETWORK_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.OCUP_BANDA_DN}{this.props.statistics.ocupBanda.toFixed(0)}</Text>
        <Text style={reusableStyles.normalText}>{Strings.BAUD_RATE_PROTOCOL}{this.getBaudRateText(this.props.statistics.baudRate)}</Text>
        <Text style={reusableStyles.normalText}>{Strings.CYCLE_TIME_PROTOCOL}{this.props.statistics.cycleTime.toFixed(2).replace(".", ",") + " ms"}</Text>

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.DEVICE_DATA}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.MASTERS_DN}{this.props.statistics.masters}</Text>
        <Text style={reusableStyles.normalText}>{Strings.SLAVES_DN}{this.props.statistics.num_devices}</Text>
        <Text style={reusableStyles.normalText}>{Strings.MISSING_DN}{this.props.statistics.missings}</Text>
        <Text style={reusableStyles.normalText}>{Strings.RETRIES_DN}{this.props.statistics.retriesTotal}</Text>
        <Text style={reusableStyles.normalText}>{Strings.DIAGNOSTIC_DN}{this.props.statistics.num_diag}</Text>
        <Text style={reusableStyles.normalText}>{Strings.FAULT_DN}{this.props.statistics.falhasTotal}</Text>
        <Text style={reusableStyles.normalText}>{Strings.ERROR_FRAME}{this.props.statistics.contErrorFrame}</Text>

        {this.getPageFooter("monitoringResume")}

      </Page >
    );
  }

  // ----------------- Live List -----------------
  createMonitoringLiveListPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        {this.getMonitoringLiveListPageTitle()}

        <View style={monitoringLiveListStyles.table}>
          {this.createMonitoringLiveListTableHeader()}
          {this.createMonitoringLiveListTable()}
        </View>

        {this.getPageFooter("monitoringLiveList")}

      </Page>
    );
  }

  getMonitoringLiveListPageTitle = () => {
    return (
      <Text style={monitoringLiveListStyles.pageTitle} fixed>{Strings.M_MONITORING_LIVE_LIST_PAGE_TITLE}</Text>
    );
  }

  createMonitoringLiveListTableHeader = () => {
    return (
      <View style={monitoringLiveListStyles.tableRow} fixed>

        <View style={monitoringLiveListStyles.addressTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={monitoringLiveListStyles.tagTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={monitoringLiveListStyles.diagnosticsTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.DIAGNOSTICS_STRING}</Text>
        </View>

        <View style={monitoringLiveListStyles.retriesTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.RETRIES_STRING}</Text>
        </View>

        <View style={monitoringLiveListStyles.faultsTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.FAULTS_STRING}</Text>
        </View>

        <View style={monitoringLiveListStyles.statusTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.STATUS}</Text>
        </View>

      </View>
    );
  }

  createMonitoringLiveListTable = () => {
    return (
      this.props.livelist.map(device => (
        <View style={monitoringLiveListStyles.tableRow} key={device.address} wrap={false}>

          <View style={monitoringLiveListStyles.addressTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{formatDeviceAddress(device.address, Strings)}</Text>
          </View>

          <View style={monitoringLiveListStyles.tableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{device.tag}</Text>
          </View>

          <View style={monitoringLiveListStyles.diagnosticsTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{this.getDiagnosticsText(device)}</Text>
          </View>

          <View style={monitoringLiveListStyles.retriesTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{this.getRetriesText(device)}</Text>
          </View>

          <View style={monitoringLiveListStyles.faultsTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{this.getFaultsText(device)}</Text>
          </View>

          {this.createMonitoringStatusCell(device)}

        </View>
      ))
    );
  }

  getDiagnosticsText = (device) => {
    if (device.status === "master") {
      return "-";
    }
    else {
      return device.contDiag;
    }
  }

  getRetriesText = (device) => {
    if (device.status === "master") {
      return "-";
    }
    else {
      return device.retries;
    }
  }

  getFaultsText = (device) => {
    if (device.status === "master") {
      return "-";
    }
    else {
      return device.fault;
    }
  }

  createMonitoringStatusCell = (device) => {
    if (device.status === "ok") {
      return (
        <View style={monitoringLiveListStyles.okTableStatusCol}>
          <Text style={monitoringLiveListStyles.tableCell}>{Strings.OK_STRING}</Text>
        </View>
      );
    }
    else if (device.status === "diag") {
      return (
        <View style={monitoringLiveListStyles.diagnosticTableStatusCol}>
          <Text style={monitoringLiveListStyles.tableCell}>{Strings.DIAGNOSTIC_STRING}</Text>
        </View>
      );
    }
    else if (device.status === "fault") {
      return (
        <View style={monitoringLiveListStyles.faultTableStatusCol}>
          <Text style={monitoringLiveListStyles.tableCell}>{Strings.FAULT_STRING}</Text>
        </View>
      );
    }
    else if (device.status === "master") {
      if (device.mestre !== null) {
        return (
          <View style={monitoringLiveListStyles.masterTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.MASTER_STRING}</Text>
          </View>
        );
      }
    }
    else if (device.status === "missing") {
      return (
        <View style={monitoringLiveListStyles.missingTableStatusCol}>
          <Text style={monitoringLiveListStyles.tableCell}>{Strings.MISSING_SINGULAR_STRING}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={monitoringLiveListStyles.missingTableStatusCol}>
          <Text style={monitoringLiveListStyles.tableCell}>{Strings.UNKNOWN_NAME}</Text>
        </View>
      );
    }
  }

  // ----------------- Log -----------------
  createMonitoringLogPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={monitoringLogStyles.pageTitle} fixed>{Strings.M_MONITORING_LOG_PAGE_TITLE}</Text>
        <Text style={monitoringLogStyles.pageLastEventsText} fixed>{Strings.LAST_200_EVENTS}</Text>

        <View style={monitoringLogStyles.table}>
          {this.createMonitoringLogTableHeader()}
          {this.createMonitoringLogTable()}
        </View>

        {this.getPageFooter("monitoringLog")}

      </Page>
    );
  }

  createMonitoringLogTableHeader = () => {
    return (
      <View style={monitoringLogStyles.tableRow} fixed>

        <View style={monitoringLogStyles.horaryTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={monitoringLogStyles.addressTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={monitoringLogStyles.modelTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={monitoringLogStyles.descriptionTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.DESCRIPTION}</Text>
        </View>

      </View>
    );
  }

  createMonitoringLogTable = () => {
    let last200Events = [];

    if (this.props.log.length > Constants.MAX_NUM_OF_LOG_EVENTS) {
      for (let i = 0; i < Constants.MAX_NUM_OF_LOG_EVENTS; i++) {
        last200Events.push(this.props.log[i]);
      }
    }
    else {
      for (let i = 0; i < this.props.log.length; i++) {
        last200Events.push(this.props.log[i]);
      }
    }

    return (
      last200Events.map(logEntry => (
        <View style={monitoringLogStyles.tableRow} key={logEntry.event} wrap={false}>

          <View style={monitoringLogStyles.horaryTableCol}>
            <Text style={monitoringLogStyles.tableCell}>{this.getMonitoringLogTime(logEntry)}</Text>
          </View>

          <View style={monitoringLogStyles.addressTableCol}>
            {logEntry.address !== undefined && logEntry.address !== null ? (
              <Text style={monitoringLogStyles.tableCell}>{formatDeviceAddress(logEntry.address, Strings)}</Text>
            ):(
              <Text style={monitoringLogStyles.tableCell}>-</Text>
            )}
          </View>

          <View style={monitoringLogStyles.modelTableCol}>
            <Text style={monitoringLogStyles.tableCell}>{this.getLogTag(logEntry)}</Text>
          </View>

          {this.getMonitoringLogDescription(logEntry)}

        </View>
      ))
    );
  }

  formatTime = (eventTimeInSeconds) => {
    if (eventTimeInSeconds !== undefined && eventTimeInSeconds !== null) {
      const eventTimeInMillis = eventTimeInSeconds * 1000;
      const uptimeInMillis = this.props.uptime * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - uptimeInMillis + eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow);
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getMonitoringLogTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);

      let year = dateToShow.getFullYear();
      let month = dateToShow.getMonth() + 1;
      let day = dateToShow.getDate();
      let hour = dateToShow.getHours();
      let minutes = dateToShow.getMinutes();

      if (day < 10) { day = "0" + day; }
      if (month < 10) { month = "0" + month; }
      if (hour < 10) { hour = "0" + hour; }
      if (minutes < 10) { minutes = "0" + minutes; }

      return day + "/" + month + "/" + year + " " + hour + ":" + minutes;
    }
    else {
      if (logEntry.time === null) {
        return Strings.BEFORE_MONITOR_INIT_STR;
      }
      else {
        let dateToShow = this.formatTime(logEntry.time);
        let year = dateToShow.getFullYear();
        let month = dateToShow.getMonth() + 1;
        let day = dateToShow.getDate();
        let hour = dateToShow.getHours();
        let minutes = dateToShow.getMinutes();

        if (day < 10) { day = "0" + day; }
        if (month < 10) { month = "0" + month; }
        if (hour < 10) { hour = "0" + hour; }
        if (minutes < 10) { minutes = "0" + minutes; }

        return day + "/" + month + "/" + year + " " + hour + ":" + minutes;
      }
    }

  }

  getLogTag = (logEntry) => {
    if (logEntry.tag === "") {
      return "-";
    }
    else {
      return logEntry.tag;
    }
  }

  getMonitoringLogDescription = (logEntry) => {
    if (logEntry.tipo === Constants.DIAGNOSTIC_LOG_EVENT_TYPE) {
      return (
        <View style={monitoringLogStyles.descriptionTableCol}>
          {logEntry.active ? (
            <>
            <Text style={monitoringLogStyles.logDescriptionTableCellTitle}>{Strings.SLAVE_DIAGNOSTIC}</Text>
            {
              logEntry.description.map(description => (
                <Text key={description} style={monitoringLogStyles.logDescriptionTableCell}>{"• " + description}</Text>
              ))
            }
            </>
            ) : (
              <Text style={monitoringLogStyles.logDescriptionTableCell}>{Strings.EVENT_CHECKED_SUCCESS_PROTOCOL}</Text>
            )}
        </View>
      );
    }
    else if (logEntry.tipo === Constants.RETRIES_LOG_EVENT_TYPE) {
      return (
        <View style={monitoringLogStyles.descriptionTableCol}>
          <Text style={monitoringLogStyles.logDescriptionTableCell}>{logEntry.active ? Strings.PROTOCOL_RETRIES_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL}</Text>
        </View>
      );
    }
    else if (logEntry.tipo === Constants.FAULTS_LOG_EVENT_TYPE) {
      return (
        <View style={monitoringLogStyles.descriptionTableCol}>
          <Text style={monitoringLogStyles.logDescriptionTableCell}>{logEntry.active ? "" : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL}</Text>
        </View>
      );
    }
    else if (logEntry.tipo === Constants.ERROR_FRAME_LOG_EVENT_TYPE) {
      return (
        <View style={monitoringLogStyles.descriptionTableCol}>
          <Text style={monitoringLogStyles.logDescriptionTableCell}>{logEntry.active ? Strings.PROTOCOL_ERROR_FRAME_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL}</Text>
        </View>
      );
    }
    else {
      if (logEntry.address === "128") {
        return (
          <View style={monitoringLogStyles.descriptionTableCol}>
            {
              logEntry.description.map(description => (
                <React.Fragment key={description}>
                  <Text style={monitoringLogStyles.logDescriptionTableCellTitle}>
                    {Strings.NETWORK_EVENT}:
                  </Text>
                  <Text style={monitoringLogStyles.logDescriptionTableCellTitle}>
                    {Strings.STATUS_CHANGE}
                    <Text style={monitoringLogStyles.logDescriptionTableCell}>{description}</Text>
                  </Text>
                </React.Fragment>
              ))
            }
          </View>
        );
      }
      else {
        return (
          <View style={monitoringLogStyles.descriptionTableCol}>
            {
              logEntry.description.map(description => (
                <Text key={description} style={monitoringLogStyles.logDescriptionTableCellTitle}>
                  {Strings.STATUS_CHANGE}
                  <Text style={monitoringLogStyles.logDescriptionTableCell}>{description}</Text>
                </Text>
              ))
            }
          </View>
        );
      }
    }
  }

  // ----------------- Live List -----------------
  createScopeLiveListPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        {this.getLiveListPageTitle()}

        <View style={scopeLiveListStyles.table}>
          {this.createLiveListTableHeader()}
          {this.createLiveListTable()}
        </View>

        {this.getPageFooter("scopeLiveList")}

      </Page>
    );
  }

  getLiveListPageTitle = () => {
    return (
      <Text style={scopeLiveListStyles.pageTitle} fixed>{Strings.B_LIVE_LIST_PAGE_TITLE}</Text>
    );
  }

  createLiveListTableHeader = () => {
    return (
      <View style={scopeLiveListStyles.tableRow} fixed>

        <View style={scopeLiveListStyles.addressTableColHeader}>
          <Text style={scopeLiveListStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={scopeLiveListStyles.tagTableColHeader}>
          <Text style={scopeLiveListStyles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={scopeLiveListStyles.ampTableColHeader}>
          <Text style={scopeLiveListStyles.tableCellHeader}>{Strings.MIN_AMPLITUDE_N}</Text>
        </View>

        <View style={scopeLiveListStyles.ampTableColHeader}>
          <Text style={scopeLiveListStyles.tableCellHeader}>{Strings.MEAN_AMPLITUDE_N}</Text>
        </View>

        <View style={scopeLiveListStyles.tableStatusColHeader}>
          <Text style={scopeLiveListStyles.tableCellHeader}>{Strings.SIGNAL}</Text>
        </View>

      </View>
    );
  }

  createLiveListTable = () => {
    return (
      this.props.scopeLiveList.map(device => (
        <View style={scopeLiveListStyles.tableRow} key={device.address} wrap={false}>

          <View style={scopeLiveListStyles.addressTableCol}>
            <Text style={scopeLiveListStyles.tableCell}>{formatDeviceAddress(device.address, Strings)}</Text>
          </View>

          <View style={scopeLiveListStyles.tagTableCol}>
            <Text style={scopeLiveListStyles.tableCell}>{this.getTagText(device)}</Text>
          </View>

          <View style={scopeLiveListStyles.ampTableCol}>
            <Text style={scopeLiveListStyles.tableCell}>{this.getAmplitudeMinText(device)}</Text>
          </View>

          <View style={scopeLiveListStyles.ampTableCol}>
            <Text style={scopeLiveListStyles.tableCell}>{this.getAmplitudeText(device)}</Text>
          </View>

          {this.createStatusCell(device)}
        </View>
      ))
    );
  }

  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      return (
        <View style={scopeLiveListStyles.okTableStatusCol}>
          <Text style={scopeLiveListStyles.tableCell}>
            {Strings.GOOD_STRING_ANALYZER_DN}
          </Text>
        </View>
      );
    }
    else if (device.status === Constants.ATTENTION) {
      return (
        <View style={scopeLiveListStyles.attentionTableStatusCol}>
          <Text style={scopeLiveListStyles.tableCell}>
            {Strings.ATTENTION_STRING}
          </Text>
        </View>
      );
    }
    else if (device.status === Constants.BAD) {
      return (
        <View style={scopeLiveListStyles.badTableStatusCol}>
          <Text style={scopeLiveListStyles.tableCell}>
            {Strings.BAD_STRING_ANALYZER_DN}
          </Text>
        </View>
      );
    }
    else {
      return (
        <View style={scopeLiveListStyles.unknownTableStatusCol}>
          <Text style={scopeLiveListStyles.tableCell}>
            {Strings.UNKNOWN_STRING}
          </Text>
        </View>
      );
    }
  }

  createWaveStatusCell = (isWaveOk) => {
    if (isWaveOk) {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-check.png`} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-warning.png`} />;
    }
  }

  createNoiseCell = (withNoise) => {
    if (!withNoise) {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-check.png`} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-warning.png`} />;
    }
  }

  // ----------------- Oscilloscope -----------------
  createOscilloscopePages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        {this.getOscilloscopePageTitle()}

        {this.createOscilloscopeImages()}

        {this.getPageFooter("scopeOscilloscope")}
      </Page>
    );
  }

  getOscilloscopePageTitle = () => {
    return (
      <Text style={oscilloscopeStyles.pageTitle} fixed>
        {Strings.B_OSCILLOSCOPE_PAGE_TITLE}
      </Text>
    );
  }

  createOscilloscopeImages = () => {
    return (
      this.props.imgURIs.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {this.getSlaveMasterText(this.props.livelistMap.get(data.address).isMaster)}
            </Text>
            {formatDeviceAddress(data.address, Strings)}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.SIGNAL_DN}
            </Text>
            {this.getStatusText(this.props.livelistMap.get(data.address).status)}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.AMPLITUDE_MIN_DN}
            </Text>
            {this.props.livelistMap.get(data.address).amplitudeMinima.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.MEAN_AMPLITUDE}:
            </Text>
            {" " + this.props.livelistMap.get(data.address).amplitudeMedia.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK}
          </Text>

          <Text style={oscilloscopeStyles.waveTitle}>{Strings.WAVE_DN}</Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View>
      ))
    );
  }

  // ----------------- Bar Graph -----------------
  createBarGraphPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        {this.getBarGraphPageTitle()}

        <Text style={ampStyles.waveTitle}>{Strings.MIN_AMPLITUDE}</Text>
        {this.createBarGraphMinImages()}

        <Text style={ampStyles.waveTitle}>{Strings.MEAN_AMPLITUDE}</Text>
        {this.createBarGraphAmpImages()}

        {this.getPageFooter("scopeBarGraph")}
      </Page>
    );
  }

  getBarGraphPageTitle = () => {
    return <Text style={ampStyles.pageTitle} fixed>{Strings.B_BAR_GRAPH_PAGE_TITLE}</Text>;
  }

  createBarGraphAmpImages = () => {
    return (
      this.props.ampImgURIs.map(data => (
        // eslint-disable-next-line react/jsx-key
        <Image src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  createBarGraphMinImages = () => {
    return (
      this.props.minAmpImgURIs.map(data => (
        // eslint-disable-next-line react/jsx-key
        <Image src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  // ----------------- Log -----------------
  createScopeLogPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={scopeLogStyles.pageTitle} fixed>{Strings.B_LOG_PAGE_TITLE}</Text>
        <Text style={scopeLogStyles.pageLastEventsText} fixed>{Strings.LAST_200_EVENTS}</Text>

        <View style={scopeLogStyles.table}>
          {this.createScopeLogTableHeader()}
          {this.createScopeLogTable()}
        </View>

        {this.getPageFooter("scopeLog")}

      </Page>
    );
  }

  createScopeLogTableHeader = () => {
    return (
      <View style={scopeLogStyles.tableRow} fixed>

        <View style={scopeLogStyles.horaryTableColHeader}>
          <Text style={scopeLogStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={scopeLogStyles.addressTableColHeader}>
          <Text style={scopeLogStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={scopeLogStyles.tagTableColHeader}>
          <Text style={scopeLogStyles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={scopeLogStyles.descriptionTableColHeader}>
          <Text style={scopeLogStyles.tableCellHeader}>{Strings.DESCRIPTION}</Text>
        </View>

      </View>
    );
  }

  createScopeLogTable = () => {
    return (
      this.props.scopeLog.map(logEntry => (
        <View wrap={false} key={logEntry.event}>
          <View style={scopeLogStyles.tableRow} key={logEntry.event}>

            <View style={scopeLogStyles.horaryTableCol}>
              <Text style={scopeLogStyles.tableCell}>{this.formatScopeDNLogTime(logEntry)}</Text>
            </View>

            <View style={scopeLogStyles.addressTableCol}>
              <Text style={scopeLogStyles.tableCell}>{formatDeviceAddress(logEntry.address, Strings)}</Text>
            </View>

            <View style={scopeLogStyles.tagTableCol}>
              <Text style={scopeLogStyles.tableCell}>{this.getLogTag(logEntry)}</Text>
            </View>

            <View style={scopeLogStyles.descriptionTableCol}>
              <Text style={scopeLogStyles.tableCell}>
                {this.getDescriptionText(logEntry)}
              </Text>
            </View>
          </View>
        </View>
      ))
    );
  }

  getDescriptionText = (logEntry) => {
    if (logEntry.tipo === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return logEntry.active ? Strings.DN_ATTENTION_SIGNAL_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo  === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return logEntry.active ? Strings.DN_BAD_SIGNAL_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo  === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return logEntry.active ? Strings.DN_CAPACITIVE_EFFECT_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo  === Constants.NOISE_PROBLEM_TYPE) {
      return logEntry.active ? Strings.DN_NOISE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo  === "estado") {
      return Strings.STATUS_CHANGE + logEntry.description;
    }
  }

  formatScopeDNLogTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      let timeNow = new Date().getTime();
      const eventTimeInMillis = logEntry.time * 1000;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "23vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter("")}

      </Page >
    );
  }

  render() {
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  boldText: {
    fontSize: 12,
    marginBottom: 2,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  subHeaderInnerText: {
    fontSize: 12,
    fontFamily: "RobotoMedium",
    marginTop: "1vh"
  },

  subHeaderInnerLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "1vh"
  },

  boldSummaryText: {
    fontSize: 14,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const generalInfoStyles = StyleSheet.create({
  notesSection: {
    maxWidth: "510pt",
    width: "90vw",
    height: "14vh"
  },

  conclusionSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "16vh"
  },

  rectangleSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },

  rectangle: {
    width: 28,
    height: 28,
    margin: "1vh vw"
  },
  signatureLine: {
    height: "1px",
    width: "40vw",
    backgroundColor: "black",
  }
});

const monitoringLiveListStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
    alignItems: "center",
    justifyContent: "center"
  },

  tableRow: {
    flexDirection: "row"
  },

  addressTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  retriesTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  faultsTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  diagnosticsTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tagTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  statusTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  blacklistTableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    color: "white",
    fontFamily: "RobotoRegular"
  },

  addressTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  retriesTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  faultsTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  diagnosticsTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  blacklistTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "black"
  },

  automaticBlacklistTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#8B0000"
  },

  okTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  diagnosticTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow"
  },

  onlineTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ADD8E6"
  },

  faultTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "red"
  },

  configErrorTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FFB6C1"
  },

  paramErrorTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#C71585"
  },

  masterTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "white"
  },

  slaveMasterFaultTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#B22222"
  },

  mpiTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    color: "white",
    backgroundColor: "navy"
  },

  missingTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#708090"
  },
});

const monitoringLogStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    fontFamily: "RobotoMedium"
  },

  pageLastEventsText: {
    fontSize: 12,
    marginBottom: "3vh",
    fontFamily: "RobotoRegular"
  },

  table: {
    display: "table",
    width: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  addressTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  modelTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  descriptionTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  addressTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  modelTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  descriptionTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  logDescriptionTableCell: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  logDescriptionTableCellTitle: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoMedium"
  }

});

const scopeLiveListStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
    alignItems: "center",
    justifyContent: "center"
  },

  tableRow: {
    flexDirection: "row"
  },

  addressTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tagTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  abTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  ampTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableStatusColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  addressTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tagTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  abTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  ampTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  okTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  attentionTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow"
  },

  badTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722"
  },

  okFadedTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime",
    opacity: 0.5
  },

  attentionFadedTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow",
    opacity: 0.5
  },

  badFadedTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722",
    opacity: 0.5
  },

  unknownTableStatusCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lightgrey"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 10,
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 5,
    fontSize: 10,
    fontFamily: "RobotoRegular"
  }
});

const oscilloscopeStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {

    height: "28vh",
    width: "87vw"
  }
});

const ampStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16
  },

  chartImgStyle: {
    height: "33vh",
    width: "87vw",
    marginTop: "1vh",
    marginBottom: "4vh"
  }
});

const scopeLogStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    fontFamily: "RobotoMedium"
  },

  pageLastEventsText: {
    fontSize: 12,
    marginBottom: "3vh",
    fontFamily: "RobotoRegular"
  },

  table: {
    display: "table",
    width: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tagTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  addressTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  descriptionTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
  },

  addressTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },

  tagTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  descriptionTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  tableCellLeft: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },
});

export default FullReport;
